"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // $unit-60

var popupMaxWidthNarrow = exports.popupMaxWidthNarrow = "480px"; // $unit-80

var popupMaxWidthDefault = exports.popupMaxWidthDefault = "640px"; // $unit-120

var popupMaxWidthWide = exports.popupMaxWidthWide = "960px";